/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class CategorieMenuItem extends PureComponent {
  render() {
    const { categories } = this.props;

    return (
      <>
        {
          categories.map((categorie, index) => {
            const categoryName = categorie.category_name === '' ? 'sem categoria' : categorie.category_name;

            return (
              <li className="animated fadeInLeft" key={index}>
                <a href={`#categoria-${categoryName}`} className="nav-link">
                  <span>{categoryName}</span>
                </a>
              </li>
            );
          })
        }
      </>
    );
  }
}

CategorieMenuItem.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
};

CategorieMenuItem.defaultProps = {
  categories: [],
};
export default CategorieMenuItem;
